import { useInfinityScroll } from '@hook/useInfinityScroll';
import { Link } from '@ui/Link';
import { Button } from '@ui/Button';
import {
  ProfileSocialFeedPostCard,
  ProfileSocialFeedPostCardSkeleton,
  SocialPost,
} from '@components/profile/ProfileSocialFeedPostCard';

import s from './ProfileSocialPostsFeed.sss';

interface Props {
  posts: SocialPost[],
  isLoading: boolean,
  hasNextPage: boolean,
  emptyTitle: string,
  emptyLink: {
    title: string,
    pathname: string,
  } | null,
  getPostUrl: (post: SocialPost) => string,
  onLoadMore: () => void,
}

export const ProfileSocialPostsFeed: React.FC<Props> = ({
  posts,
  isLoading,
  hasNextPage,
  emptyTitle,
  emptyLink,
  getPostUrl,
  onLoadMore,
}) => {
  const ref = useInfinityScroll(onLoadMore, 1500);

  if (!isLoading && !posts.length) {
    return (
      <div className={s.empty}>
        {emptyTitle}

        {!!emptyLink && (
          <Button
            className={s.emptyButton}
            to={emptyLink.pathname}
          >
            {emptyLink.title}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div
      ref={ref}
      className={s.root}
    >
      <ul className={s.list}>
        {isLoading && (
          Array(8).fill(null).map((_, i) => (
            <li
              key={i}
              className={s.item}
            >
              <ProfileSocialFeedPostCardSkeleton />
            </li>
          ))
        )}

        {posts.map((post) => (
          <li
            key={post.id}
            className={s.item}
          >
            <Link
              className={s.link}
              theme="clean"
              to={getPostUrl(post)}
            >
              <ProfileSocialFeedPostCard post={post} />
            </Link>
          </li>
        ))}

        {hasNextPage && (
          Array(4).fill(null).map((_, i) => (
            <li
              key={i}
              className={s.item}
            >
              <ProfileSocialFeedPostCardSkeleton />
            </li>
          ))
        )}
      </ul>
    </div>
  );
};
